import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: {
        id: string
    }
}

const { onDeleteRequest, onRequest, onEditFailure } = rootActions.companies.contactCompany
const { setEmployeesEditorModal } = rootActions.ui.companyProfile

function* contactDeleteCompanySagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/companies/contacts/${payload.id}`)

        if (response.success) {
            yield put(onRequest({ id: payload.data.company }))
            yield put(setEmployeesEditorModal({ isOpen: false, data: {} }))
        }
    } catch (error) {
        yield put(onEditFailure(error))
    }
}

function* contactDeleteCompanySaga(): any {
    yield takeLatest<TaskAction>(onDeleteRequest, contactDeleteCompanySagaTask)
}

export default contactDeleteCompanySaga
